import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { Observable } from 'rxjs';
import { DocumentoPac } from 'src/app/model/DocumentoPac';
import {AppRole} from 'src/app/common/constants/app-role.constant';
import { PesquisaPropostaDto } from 'src/app/model/dto/PesquisaPropostaDto';
import { PacService } from 'src/app/services/pac.service';
import { BnUsuarioService, Usuario} from '@bndes/bndes-ux4/bn-usuario';

@Component({
  selector: 'app-detalhe-da-proposta',
  templateUrl: './detalhe-da-proposta.component.html',
  styleUrls: ['./detalhe-da-proposta.component.scss'],
  standalone: false
})
export class DetalheDaPropostaComponent implements OnInit {

  documentoPac: DocumentoPac
  usuario: Usuario;
  proposta: PesquisaPropostaDto;
  numeroPAC: string;
  $observablePac: Observable<DocumentoPac>;

  exibirHistoricoPac: boolean = true;
  isExibirAnaliseCondicionadas: boolean = true;

  labelButton: string = "Expandir";
  
  private nomesGrupos= ['informacoespac', 
                    'informacoescompradora',
                    'informacoesfabricante', 
                    'informacoesinvestimento',
                    'informacoesoperacaogarantia',
                    'informacoesequipamentos',
                    'informacoesanexos',
                    'informacoespedidoliberacao',
                    'informacoesaditivos',
                    'informacoeshistorico',
                    'informacoescancelamentosaldo',
                    'informacoesAnaliseCondicionadas'
                  ]
  constructor(
    private pacService: PacService,
    private router: ActivatedRoute,
    private usuarioService: BnUsuarioService
  ) { }


  async ngOnInit() {
    this.usuarioService.usuario$.subscribe(
      (usuario: Usuario) => {
        this.usuario = usuario;
        this.definePermisoes();
      });
    this.router.queryParams.subscribe(
      (queryParams: any) => {
        this.proposta = new PesquisaPropostaDto();
        this.proposta.id = queryParams['id'] ? queryParams['id'] : undefined
      }
      )
      await this.pacService.obterPacPromisse(this.proposta.id).then(pac => this.documentoPac = pac)
  }

  expandir(){

    if(this.labelButton === "Expandir"){
      this.labelButton = "Colapsar"
    }else{
      this.labelButton = "Expandir"
    }


    this.nomesGrupos.forEach(idComponente => {
      if(this.labelButton === "Expandir" && document.getElementById(idComponente) && document.getElementById(idComponente).classList.contains('show')){
        document.getElementById(idComponente).classList.remove('show')
      }else if(this.labelButton === "Colapsar" && document.getElementById(idComponente) && !document.getElementById(idComponente).classList.contains('show'))
        document.getElementById(idComponente).classList.add('show')
      
    })

  }

  expadirBloco(idComponente: string){
    document.getElementById(idComponente).classList.toggle('show')

    if(this.labelButton === "Expandir"){
      if(this.nomesGrupos.find(g => !document.getElementById(g).classList.contains('show')) == undefined){
        this.labelButton = "Colapsar"
      }
    }else{
      if(this.nomesGrupos.find(g => document.getElementById(g).classList.contains('show')) == undefined){
        this.labelButton = "Expandir"
      }
    }
  }
  
  //GRUPO 7
  exibirAnaliseCondicionadas(exibir: boolean){
    this.isExibirAnaliseCondicionadas = exibir
  }

  private definePermisoes(){
    if(this.usuario.possuiPermissao(AppRole.AGENTE_FINANCEIRO)){
        this.exibirHistoricoPac = false;
        this.isExibirAnaliseCondicionadas = false;
    } else {
        this.exibirHistoricoPac = true;
        this.isExibirAnaliseCondicionadas = true;
    }
  }

  get numeroPacToString(): String{
    return  new String(this.documentoPac.numeroPac || '000000').padStart(6, '0');
  }
}